'use client';
import { AddPlayersPanel } from '@/modules/league/new-components/add-players-components/AddPlayersPanel';

interface AddPlayerPanelWrapperProps {
  params: { slug: string; sessionId: string; matchDateId: string };
}

const AddPlayersWrapper = ({ params }: AddPlayerPanelWrapperProps) => {
  return <AddPlayersPanel params={params} />;
};

export default AddPlayersWrapper;
